// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React, { ReactElement, SyntheticEvent, FormEvent } from "react";
import { MessageFormatHandler } from "../messageBox/messageBox";
import { getDarkTheme, getPrimaryBlueTheme } from "../../../../common/themes";
import {
    Customizer,
    Dialog,
    DialogContent,
    DialogFooter,
    DialogType,
    ICustomizations,
    ITheme,
    PrimaryButton,
} from "@fluentui/react";
import FileUploader from "../fileUploader/fileUploader";
import { IProject } from "../../../../models/applicationState";
import './fileUploaderDialog.css';
import { Checkbox } from "@fluentui/react";
/**
 * Properties for Alert Component
 * @member closeButtonText - Text displayed on 'Close' button. Default 'OK'
 * @member onClose - Function to execute on alert close
 * @member confirmButtonTheme - Theme of 'Confirm' button
 */
export interface IFileUploaderDialogProps {
    title?: string;
    message: string | ReactElement<any> | MessageFormatHandler;
    closeButtonText?: string;
    confirmButtonTheme?: ITheme;
    show?: boolean;
    onClose?: () => void;
    uploadType: string;
    onUploadComplete: (sender: SyntheticEvent, array: string[]) => void;
    project?: IProject;
}

/**
 * State for Alert Component
 * @member params - Arguments passed in the open command
 */
export interface IFileUploaderDialogState {
    params: any[];
    sessionId: string;
    splitFiles: boolean;
}

/**
 * @name - Alert
 * @description - Generic Alert dialog
 */
export default class FileUploaderDialog extends React.Component<
    IFileUploaderDialogProps,
    IFileUploaderDialogState
> {
    // hachet
    constructor(props, context) {
        super(props, context);

        this.state = {
            params: null,
            sessionId: this.createSessionId(),
            splitFiles: false
        };

        this.onCloseClick = this.onCloseClick.bind(this);
    }

    private createSessionId() {
        return (
            "session-" +
            "xxxx-xxxx".replace(/[xy]/g, function (c) {
                // tslint:disable-next-line: one-variable-per-declaration
                let r = (Math.random() * 16) | 0,
                    v = c === "x" ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            })
        );
    }

    public render() {
        const dark: ICustomizations = {
            settings: {
                theme: getPrimaryBlueTheme(),
            },
            scopedSettings: {},
        };

        return (
            
                <Dialog
                    onDismiss={this.onCloseClick}
                    hidden={!this.props.show}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: this.props.title,
                        isMultiline: true,
                    }}
                    minWidth="700px"
                    modalProps={{
                        isBlocking: true,
                        className: 'file-uploader-main'
                    }}                    
                >
                    <DialogContent className="file-uploader-dialog">
                        <FileUploader
                            sessionId={this.state.sessionId}
                            uploadType={this.props.uploadType}
                            onDialogClosed={this.onCloseClick}
                            onChange={this.onChange}
                            onError={this.onError}
                            onUploadComplete={this.props.onUploadComplete}
                            project={
                                this.props.project ? this.props.project : null
                            }
                            splitMultiplePageFiles={this.state.splitFiles}
                    />
                    {
                        this.props.uploadType === "documents" &&
                        <Checkbox
                            label="Split multiple page files"
                            onChange={this.onSplitMultiplePageFilesCheckChanged}
                            checked={this.state.splitFiles}
                        />
                    }
                        
                    </DialogContent>
                    {/*<DialogFooter>*/}
                    {/*    <PrimaryButton*/}
                    {/*        theme={getPrimaryBlueTheme()}*/}
                    {/*        onClick={this.onCloseClick}*/}
                    {/*        text="Close"*/}
                    {/*    />*/}
                    {/*</DialogFooter>*/}
                </Dialog>
            
        );
    }

    private onError() {}

    private onChange() {}

    private onCloseClick() {
        if (this.props.onClose) {
            this.setState({
                sessionId: this.createSessionId(),
            });
            this.props.onClose.apply(null, this.state.params);
        }
    }

    private onSplitMultiplePageFilesCheckChanged = (
        ev?: FormEvent<HTMLElement | HTMLInputElement>,
        checked?: boolean
    ) => {
        this.setState({
            splitFiles: checked,
        });
    };
}
